<template>
    <div class="ticket-code">
        <div class="card-bar"></div>

        <div class="whole">
            <div class="card  ql-snow">
                <div class="ql-editor" v-if="appData.title" v-html="appData.title"></div>
                <div class="user-data">
                    <div class="avatar" v-if="appData.avatar && userInfo.photo">

                        <img :src="userInfo.photo" alt="">
                    </div>
                    <div class="app-content ql-editor" v-html="appData.content"></div>
                </div>
                <div class="qrcode">
                    <div class="qrcode-content" v-if="userInfo.code">
                        <vue-qr :text="userInfo.code" :colorDark="qrOption.colorDark" backgroundColor="#fff" :size="170"></vue-qr>
                        <!-- <div class="qr-mask" v-if="userInfo.status == null || userInfo.status == 0">
                            <span>请等待审核</span>
                        </div> -->
                    </div>

                    <div class="date-time" v-if="appData.time">
                        <span v-if="userInfo.idCardType == '外商证'">Real time</span>
                        <span v-else>实时时间</span>
                        <div>
                            <div class="date">{{ date }}</div>
                            <div class="time">{{ time }}</div>
                        </div>
                    </div>
                </div>
                <div class="ql-snow">
                    <div class="ql-editor" v-html="appData.prompt"></div>
                </div>
            </div>
            <dashed-line :num="28"></dashed-line>
            <div class="banner" v-if="appData">
                <img :src="appData.banner" alt />
            </div>

            <!-- <div class="support">技术支持：三体智通科技有限公司</div> -->
        </div>

    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import vueQr from 'vue-qr';
import DashedLine from '../../components/DashedLine.vue';
import { mapGetters } from 'vuex';
export default {
    props: {
        userInfo: {
            type: Object,
            default() {
                return null;
            },
        },
        appData: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            waitHsVerify: false,
            refresh: false,
            date: '',
            qrOption: {
                colorDark: '#333',
            },
            Count: 0,
            time: '',
            timerID: null,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    components: {
        vueQr,
        DashedLine,
    },
    methods: {
        updateTime() {
            var ctx = this;
            var cd = new Date();
            this.time =
                ctx.zeroPadding(cd.getHours(), 2) +
                ':' +
                ctx.zeroPadding(cd.getMinutes(), 2) +
                ':' +
                ctx.zeroPadding(cd.getSeconds(), 2);
            this.date = ctx.zeroPadding(cd.getMonth() + 1, 2) + '-' + ctx.zeroPadding(cd.getDate(), 2) + ' ';
        },

        zeroPadding(num, digit) {
            var zero = '';
            for (var i = 0; i < digit; i++) {
                zero += '0';
            }
            return (zero + num).slice(-digit);
        },

        onRefreshTime() {
            this.$emit('UpdateData', 1);
        },

        handleUpHsImg() {
            this.$emit('UpHsImg');
        },
    },

    mounted() {
        console.log(this.defaultInfo);
        this.timerID = setInterval(this.updateTime, 1000);
    },
    beforeDestory() {
        clearInterval(this.timerID);
    },
};
</script>

<style lang="scss" scoped>
.ticket-code {
    .card-bar {
        height: 20px;
        background: #616161;
        border-radius: 20px;
        z-index: -1;
    }
    .whole {
        padding: 0 10px 10px 10px;
        .card {
            background: #fff;
            position: relative;
            padding: 16px 20px;
            margin-top: -10px;

            .user-data {
                display: flex;

                .avatar {
                    img {
                        width: 80px;
                        height: auto;
                    }
                }
                .app-content {
                    flex: 1;
                }
            }

            .prompt {
                color: #999;
                .title {
                    padding: 12px 20px 0;
                    font-size: 16px;
                    text-align: center;
                    color: #222;
                    p {
                        text-align: center;
                        padding: 6px 0;
                        span {
                            font-weight: bold;
                        }
                    }
                    p {
                    }
                }
                p {
                    text-align: center;
                }
            }
            .qrcode {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                position: relative;
                .qrcode-content {
                    display: flex;
                    justify-content: center;
                    .qr-mask {
                        position: absolute;
                        z-index: 1;
                        top: 0;

                        left: 50%;
                        transform: translateX(-50%);
                        width: 170px;
                        height: 170px;
                        background: rgba(250, 250, 250, 0.8);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span {
                            font-weight: bold;
                        }
                    }
                }
                .date-time {
                    font-size: 14px;
                    border-radius: 0 0 10px 10px;
                    background: #fff;
                    color: #f00;
                    padding: 0 10px;
                    text-align: center;
                    span {
                    }
                    div {
                        font-size: 18px;
                        display: flex;
                        justify-content: center;
                        .date {
                            margin-right: 20px;
                        }
                        .time {
                        }
                    }
                }
            }
        }
        .ql-snow {
        }

        .banner {
            width: 100%;
            position: relative;
            font-size: 0;
            img {
                width: 100%;
            }
        }
        .banner::after {
            position: absolute;
            left: -10px;
            top: -10px;
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 20px;
            background: #f8f8f8;
        }

        .banner::before {
            position: absolute;
            right: -10px;
            top: -10px;
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 20px;

            background: #f8f8f8;
        }
    }
}
</style>